@if (isLoaded()) {
  @if (!showLayout()) {
    <router-outlet />
  } @else {
    <main class="app-container">
      <div class="home-container">
        <app-header
          class="header-home"
          [(isSidebarOpen)]="sidenavOpen"
        ></app-header>

        <mat-sidenav-container hasBackdrop="false">
          <mat-sidenav
            #sidenav
            [disableClose]="!isXSmallViewport()"
            [mode]="!isXSmallViewport() ? 'side' : 'push'"
            [opened]="!isXSmallViewport() || sidenavOpen()"
            [fixedInViewport]="true"
            fixedTopGap="64"
            class="sidenav-home"
          >
            <app-menu-tree class="app-menu-tree"></app-menu-tree>
            <div class="user-card-container">
              @if (showUserCard()) {
                <app-user-details-card />
              }
              <app-version-display></app-version-display>
            </div>
          </mat-sidenav>

          <mat-sidenav-content>
            <div class="page-wrapper">
              <!-- BROWSER OUTDATED INFO -->
              <app-user-agent-outdated-banner> </app-user-agent-outdated-banner>
              <!-- ROUTER -->
              <router-outlet
                (activate)="onRouterOutletActivate()"
              ></router-outlet>
            </div>
          </mat-sidenav-content>
        </mat-sidenav-container>
      </div>
    </main>
  }
} @else {
  <div class="loading-container">
    <div class="loading-video">
      <img src="assets/logo-animated.gif" alt="loading..." />
      @if (!this.apiIsRunning()) {
        <div>
          {{ 'labels.error.not-available' | translate }}
        </div>
      }
    </div>
  </div>
}
